import type { HostOperationInput } from './contracts';
import type { JsonObject } from 'flare-chat-core/contracts';
const PARAMETER_FIELDS = new Set([
  'auto_input_submission', 'skill_id', 'capability_ids', 'selected_capability_id',
  'command', 'action_key', 'target_mode', 'function_type', 'mode', 'manual_mode', 'current_mode',
  'completion_policy', 'mode_activation', 'run_id', 'resume_collection', 'round_control',
  'interaction_id', 'resume_run_id', 'question_answer', 'answer_value', 'current_question',
  'patch_question_answer', 'patch_question_cancel', 'patch_question_node',
  'active_artifact_context', 'target_artifact_ref', 'target_tabs', 'canvas_content', 'source_grounding',
]);
const OPTION_FIELDS = new Set([
  'parameters', 'modeKey', 'manualModeKey', 'actionKey', 'targetMode', 'executionProfile',
  'modePreference', 'runtimePreferences', 'runId', 'runEventAfterSequence',
]);
const record = (value: unknown): value is JsonObject => value !== null && typeof value === 'object' && !Array.isArray(value);

const validateRuntimeOptions = (input: JsonObject) => {
  if (input.runtimePreferences !== undefined && !record(input.runtimePreferences)) throw new TypeError('Runtime preferences must be an object');
  if (input.runEventAfterSequence !== undefined && (!Number.isInteger(input.runEventAfterSequence) || typeof input.runEventAfterSequence !== 'number' || input.runEventAfterSequence < 0)) {
    throw new TypeError('Run cursor must be nonnegative');
  }
};

/** Product schema lives in the Xiaocai application, never in the generic Controller. */
export function validateHostOperationInput(input: unknown): asserts input is HostOperationInput {
  if (!record(input) || Object.keys(input).some((key) => !OPTION_FIELDS.has(key))) throw new TypeError('Unsupported Xiaocai operation input');
  if (!record(input.parameters) || Object.keys(input.parameters).some((key) => !PARAMETER_FIELDS.has(key))) {
    throw new TypeError('Unsupported Xiaocai operation parameter');
  }
  Object.entries(input).filter(([key]) => !['parameters', 'runtimePreferences', 'runEventAfterSequence'].includes(key)).forEach(([, value]) => {
    if (typeof value !== 'string') throw new TypeError('Operation option must be text');
  });
  validateRuntimeOptions(input);
}
